import { SxProps, Theme } from '@mui/material/styles'

// Secondary color constant - matches theme.ts SECONDARY_COLOR
export const SECONDARY_COLOR = '#444444'

// Common icon button styling for grey icons
export const greyIconButtonSx: SxProps<Theme> = {
    color: SECONDARY_COLOR,
    '& .MuiSvgIcon-root': {
        color: SECONDARY_COLOR,
    },
    '& svg': {
        color: SECONDARY_COLOR,
    },
}

// Common button styling for grey buttons with icons
export const greyButtonSx: SxProps<Theme> = {
    color: SECONDARY_COLOR,
    '& .MuiSvgIcon-root': {
        color: SECONDARY_COLOR,
    },
    '& svg': {
        color: SECONDARY_COLOR,
    },
    '& .MuiTypography-root': {
        color: SECONDARY_COLOR,
    },
}

